module.exports = __webpack_public_path__ + "media/images/icons/ic-arrow-up-54383f322c5da44aed2014cf72a2c394.svg";